import { IndicatorProps } from '@mantine/core';

import indicatorClasses from './Indicator.module.css';

export const DefaultIndicatorProps: Partial<IndicatorProps> = {
  radius: 'sm'
};

export const IndicatorOverrideClassNames = () => {
  return {
    indicator: indicatorClasses.indicator
  };
};
